import {TERMS_AND_CONDITIONS_AU } from "../../utils/constants"


const initialState = [];

function termsAndConditonsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case TERMS_AND_CONDITIONS_AU:
            return [...state, payload];
        default:
            return state;
    }
};

export default termsAndConditonsReducer;